import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { smoothScrollToElement } from '../../scroll';
import CosmicProfile from './cosmic-profile';
import EmailAddress from './email-address';
import ForumsUsername from './forums-username';
import MoreAboutYou from './more-about-you';
import Password from './password';
import TimeZone from './time-zone';
import ProfilePicture from './profile-picture';
import TarotDeck from './tarot-deck';

class Component extends BaseComponent {
    componentDidMount() {
        this.props.getDetails();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.route != this.props.route) {
            return true;
        }

        if (nextProps.user != this.props.user) {
            return true;
        }

        if (nextProps.fields != this.props.fields) {
            return true;
        }

        if (nextProps.errors != this.props.errors) {
            return true;
        }

        if (nextProps.success != this.props.success) {
            return true;
        }

        if (nextProps.isDirty != this.props.isDirty) {
            return true;
        }

        if (nextProps.hasErrors != this.props.hasErrors) {
            return true;
        }

        if (nextProps.isSubmitting != this.props.isSubmitting) {
            return true;
        }

        if (nextProps.drts != this.props.drts) {
            return true;
        }

        return false;
    }

    /* eslint-disable complexity, max-len */
    render({ route }) {
        return (
            <account-settings>
                <form autoComplete='off'>
                    <row className='is-wrap'>
                        <column className='is-9 is-12-mobile has-padding-20-right-desktop has-padding-20-right-tablet'>
                            <div className='has-padding-10-left-mobile has-padding-10-right-mobile'>
                                <h2 className='is-hidden-mobile has-margin-15-bottom'>Update Your Profile Information</h2>
                                <h5 className='is-visible-mobile has-margin-20-bottom'>Update Your Profile Information</h5>
                                <p>
                                    <a href='/member/profiles'>Profiles Manager</a>
                                    <br />
                                    <span className='has-text-size-15'>Update your personal details like name, birthdate and friend profiles here.</span>
                                </p>
                                <p>
                                    <a href='/member/emails'>Email Preferences</a>
                                    <br />
                                    <span className='has-text-size-15'>Manage which emails you wish to receive from us.</span>
                                </p>
                                <p>
                                    <a href='https://product.tarot.com/about-you/account/'>My Karma Coin History</a>
                                    <br />
                                    <span className='has-text-size-15'>View purchases made with Karma Coins.</span>
                                </p>
                                <p>
                                    <a href='/store/karma-coins'>Karma Coin Store</a>
                                    <br />
                                    <span className='has-text-size-15'>Get up to 50% more readings with Karma Coins!</span>
                                </p>
                                {this.renderVIPLink()}
                                {this.renderDRSTLink()}
                            </div>
                            <section className={route == 'your-profile-picture' ? 'is-open' : ''} id='your-profile-picture'>
                                <h2 className='has-margin-15-bottom is-hidden-mobile'>Your Profile Picture</h2>
                                <a onClick={this.goTo} href='#your-profile-picture' className='is-visible-mobile'>
                                    <h5>Your Profile Picture</h5>
                                </a>
                                <p className='is-visible-mobile'>Update your default photo</p>
                                <ProfilePicture onChange={this.handleChange} />
                            </section>
                            <section className={route == 'your-password' ? 'is-open' : ''} id='your-password'>
                                <h2 className='has-margin-15-bottom is-hidden-mobile'>Your Password</h2>
                                <a onClick={this.goTo} href='#your-password' className='is-visible-mobile'>
                                    <h5>Your Password</h5>
                                </a>
                                <p>Update your account password</p>
                                <Password onChange={this.handleChange} />
                            </section>
                            <section className={route == 'your-email-address' ? 'is-open' : ''} id='your-email-address'>
                                <h2 className='has-margin-15-bottom is-hidden-mobile'>Your Email Address</h2>
                                <a onClick={this.goTo} href='#your-email-address' className='is-visible-mobile'>
                                    <h5>Your Email Address</h5>
                                </a>
                                <p>Update your login email address</p>
                                <EmailAddress onChange={this.handleChange} />
                                <p><a href='/member/emails'>Update your email preferences</a></p>
                            </section>
                            <section
                                className={route == 'your-time-zone' ? 'is-open' : ''}
                                id='your-time-zone'
                            >
                                <h2 className='has-margin-15-bottom is-hidden-mobile'>Your Time Zone</h2>
                                <a onClick={this.goTo} href='#your-time-zone' className='is-visible-mobile'>
                                    <h5>Your Time Zone</h5>
                                </a>
                                <p>Update your Time Zone</p>
                                <TimeZone onChange={this.handleChange} />
                            </section>
                            <section className={route == 'more-about-you' ? 'is-open' : ''} id='more-about-you'>
                                <h2 className='has-margin-15-bottom is-hidden-mobile'>Tell Us More About You</h2>
                                <a onClick={this.goTo} href='#more-about-you' className='is-visible-mobile'>
                                    <h5>Tell Us More About You</h5>
                                </a>
                                <p>Update to help us customize your experience</p>
                                <MoreAboutYou onChange={this.handleChange} />
                            </section>
                            {this.renderForum()}
                        </column>
                        <column className='is-3 is-12-mobile'>
                            <section
                                className={`has-margin-40-bottom-desktop has-margin-40-bottom-tablet ${route == 'your-tarot-deck' ? 'is-open' : ''}`}
                                id='your-tarot-deck'
                            >
                                <h2 className='has-margin-15-bottom is-hidden-mobile'>Your<br />Favorite<br />Tarot Deck</h2>
                                <a onClick={this.goTo} href='#your-tarot-deck' className='is-visible-mobile'>
                                    <h5>Your Favorite Tarot Deck</h5>
                                </a>
                                <p>Choose the deck you prefer to use in your Tarot readings</p>
                                <TarotDeck onChange={this.handleChange} />
                            </section>
                            <section
                                className={`has-margin-20-bottom-desktop has-margin-20-bottom-tablet ${route == 'your-cosmic-profile' ? 'is-open' : ''}`}
                                id='your-cosmic-profile'
                            >
                                <h2 className='has-margin-15-bottom is-hidden-mobile'>Your<br />Cosmic<br />Profile</h2>
                                <a onClick={this.goTo} href='#your-cosmic-profile' className='is-visible-mobile'>
                                    <h5>Your Cosmic Profile</h5>
                                </a>
                                <p>See how your birth information shapes your unique identity! <a href='/cosmic-profile'>Get your Cosmic Profile now >></a></p>
                                <CosmicProfile onChange={this.handleChange} />
                            </section>
                        </column>
                    </row>
                    <row>
                        <column className='is-12 has-text-center has-padding-30'>
                            <button
                                className={`button ${this.props.isSubmitting || !this.props.isDirty || (this.props.isDirty && this.props.hasErrors)
                                    ? 'disabled'
                                    : ''
                                }`}
                                disabled={this.props.isSubmitting || !this.props.isDirty || (this.props.isDirty && this.props.hasErrors)}
                                onClick={this.submitForm}
                            >
                                {this.props.isSubmitting ? 'Submitting…' : 'SAVE CHANGES'}
                            </button>
                            {this.renderError()}
                        </column>
                    </row>
                </form>
            </account-settings>
        );
    }
    /* eslint-enable complexity, max-len */

    renderVIPLink = () => {
        if (
            this.props.user
            &&
            this.props.user.subscriptions
            &&
            this.props.user.subscriptions.vip
        ) {
            return (
                <p>
                    <a href='/member/subscription/vip'>Membership Subscription</a>
                    <br />
                    <span className='has-text-size-15'>Manage your VIP Membership subscription.</span>
                </p>
            );
        }

        return null;
    }

    renderDRSTLink = () => {
        if (
            this.props.user
            &&
            this.props.user.subscriptions
            &&
            this.props.user.subscriptions.drts
        ) {
            return (
                <p>
                    <a href='/member/subscription/drt-monthly-subscription'>Daily Tarot Subscription</a>
                    <br />
                    <span className='has-text-size-15'>Manage your Daily Tarot subscription.</span>
                </p>
            );
        }

        return null;
    }

    goTo = (e) => {
        e.preventDefault();

        const elem = (e.target.tagName != 'A') ? e.target.parentNode : e.target;
        const hash = elem.hash.replace(/#/, '');

        this.props.routeTo('');

        if (hash != this.props.route) {
            this.props.routeTo(hash);

            if (hash != '') {
                setTimeout(() => {
                    smoothScrollToElement(document.querySelector(`#${hash}`));
                }, 220);
            }
        }
    }

    handleChange = (name, value, error = null, formError = null) => {
        const fields = this.props.fields;
        const errors = this.props.errors;

        if (name) {
            fields[name] = value || null;

            if (error) {
                errors[name] = error;
            } else if (errors[name]) {
                delete errors[name];
            }
        }

        this.setState({ errors: Object.keys(errors).length });

        this.props.updateForm({
            success: false,
            errors: errors,
            fields: fields,
            error: Object.keys(errors).length || formError,
            dirty: Object.keys(fields).length,
        });
    }

    renderError = () => {
        if (this.props.hasErrors) {
            if (this.props.errors.general) {
                return (
                    <p className='is-error'>{this.props.errors.general}</p>
                );
            }

            return (
                <p className='is-error'>Please correct the field{this.props.hasErrors > 1 ? 's' : ''} marked in red</p>
            );
        } else if (this.props.success) {
            return (
                <p className='is-success'>Your settings have been saved!</p>
            );
        }

        return null;
    }

    renderForum = () => {
        if (!this.props.user.forum_name) {
            return (
                <section className={this.props.route == 'join-our-community' ? 'is-open' : ''} id='join-our-community'>
                    <h2 className='has-margin-15-bottom is-hidden-mobile'>Join Our Forums Community</h2>
                    <a onClick={this.goTo} href='#join-our-community' className='is-visible-mobile'>
                        <h5>Join Our Forums Community</h5>
                    </a>
                    <p className='has-padding-20-right'>
                        Your unique username will allow you to post and reply to topics in our&nbsp;
                        <a href='https://forums.tarot.com'>Tarot.com forums</a> and personalize your forums
                        profile page.
                    </p>
                    <ForumsUsername onChange={this.handleChange} />
                </section>
            );
        }

        return null;
    }

    submitForm = () => {
        if (this.props.isDirty && !this.props.hasErrors) {
            this.props.memberUpdate();
        }
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
    user: state.user,
    fields: state.settings && state.settings.fields || {},
    errors: state.settings && state.settings.errors || {},
    success: state.settings && state.settings.success,
    isDirty: state.settings && state.settings.dirty,
    hasErrors: state.settings && state.settings.error,
    isSubmitting: state.settings && state.settings.submitting,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
    memberUpdate: () => dispatch({ type: 'member:update-settings' }),
    updateForm: (payload) => dispatch({ type: 'settings:update', payload: payload }),
    getDetails: () => dispatch({ type: 'member:get-details' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);